import { render } from "./ViewAdminGaleria.vue?vue&type=template&id=662a5b65&scoped=true"
import script from "./ViewAdminGaleria.vue?vue&type=script&lang=js"
export * from "./ViewAdminGaleria.vue?vue&type=script&lang=js"

import "./ViewAdminGaleria.vue?vue&type=style&index=0&id=662a5b65&scoped=true&lang=css"
import "./ViewAdminGaleria.vue?vue&type=style&index=1&id=662a5b65&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662a5b65"]])

export default __exports__